<template>
  <v-card class="page__progressBar" flat>
    <v-row no-gutters class="py-0 px-2">
      <v-col cols="12" class="px-0 d-flex flex-column">
        <div
          class="text-none cursor-pointer d-flex align-center mb-2"
          @click="beforeLeave"
        >
          <span class="body-bold-smaller page__progressBar--back">
            <v-icon
              class="body-bold-smaller page__progressBar--back-icon"
              size="11px"
              >mdi-arrow-left</v-icon
            >
            {{ $t('message.actions.return') }}
          </span>
        </div>
        <span
          class="body-bold-medium page__progressBar--title"
          style="vertical-align: middle"
        >
          {{ $t('message.pages.video.progressBar') }}
        </span>
      </v-col>
    </v-row>

    <v-row no-gutters class="py-0 px-2 mb-2">
      <v-col cols="12">
        <v-card flat>
          <span class="body-regular-smaller page__progressBar--subtext">
            {{ $t('message.pages.video.messageProgressBar') }}
            <span
              class="cursor-pointer body-bold-smaller page__progressBar--article"
              @click="openHelp"
              >{{ $t('message.actions.knowMoreHere') }}
              <v-icon size="11px" class="page__progressBar--article-icon"
                >mdi-open-in-new</v-icon
              ></span
            >
          </span>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="py-0 px-2">
      <v-col cols="12">
        <span class="body-bold-base page__progressBar--title">
          {{ $t('message.pages.video.progressBar') }}
        </span>
      </v-col>
    </v-row>

    <v-row no-gutters class="px-2">
      <v-col cols="12">
        <v-row class="mt-3">
          <v-col
            cols="12"
            class="py-0 d-flex justify-space-between align-center pr-0"
          >
            <div class="d-flex flex-column">
              <span class="body-regular-small page__progressBar--title">{{
                $t('message.pages.video.activeProgressBar')
              }}</span>
              <span
                class="body-regular-smaller page__progressBar--desc-feature"
                >{{ $t('message.pages.video.descProgressBar') }}</span
              >
            </div>
            <v-switch
              class="mt-0 mr-0"
              v-model="alternativeProgress"
              @click="activateBar"
              hide-details
              :disabled="!hasEditVideoPerm"
            ></v-switch>
          </v-col>
          <v-scroll-x-transition mode="out-in" hide-in-live>
            <v-row v-if="alternativeProgress" no-gutters>
              <v-col cols="12">
                <v-divider class="my-6"></v-divider>
                <div>
                  <v-col cols="12" class="py-1">
                    <span class="body-bold-base page__progressBar--title">
                      {{ $t('message.pages.video.titleConfigBar') }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex justify-space-between align-end pr-0"
                  >
                    <div class="d-flex flex-column">
                      <span
                        class="body-regular-small page__progressBar--title"
                        >{{
                          $t(
                            'message.pages.video.messageProgressBarRecommended'
                          )
                        }}</span
                      >
                    </div>
                    <v-switch
                      class="d-flex align-center my-2 mr-0"
                      v-model="alternativeProgressDefaultVelocity"
                      @change="changePlayer"
                      :disabled="!hasEditVideoPerm"
                      hide-details
                    ></v-switch>
                  </v-col>
                </div>
              </v-col>
              <v-scroll-x-transition mode="out-in" hide-in-live>
                <v-row no-gutters v-if="!alternativeProgressDefaultVelocity">
                  <v-col
                    cols="12"
                    class="pt-3 pb-0 pl-4 range-slider-saveProgress"
                  >
                    <v-row>
                      <v-col cols="6">
                        <div class="d-flex flex-column">
                          <span
                            class="body-regular-small page__progressBar--title"
                          >
                            {{ $t('message.pages.video.height') }}
                          </span>
                          <span
                            class="body-regular-smaller page__progressBar--desc-feature"
                            >{{ $t('message.pages.video.heightDesc') }}</span
                          >
                        </div>
                      </v-col>
                      <v-col cols="6" class="d-flex">
                        <v-slider
                          v-model="alternativeProgressHeight"
                          :disabled="!alternativeProgress || !hasEditVideoPerm"
                          @change="changePlayer"
                          hide-details
                          :min="1"
                          :max="100"
                          class="d-flex align-center"
                        >
                          <template #prepend>
                            <div
                              class="minmaxcontainer d-flex align-center body-regular-smaller"
                            >
                              <p
                                class="minmax first mb-0 page__progressBar--subtext"
                              >
                                1
                              </p>
                            </div>
                          </template>
                          <template #append>
                            <div
                              class="minmaxcontainer d-flex align-center body-regular-smaller"
                            >
                              <p class="minmax mb-0 page__progressBar--subtext">
                                100
                              </p>
                            </div>
                          </template>
                        </v-slider>
                        <div class="ml-2">
                          <v-input
                            style="width: 65px"
                            size="small"
                            v-model="alternativeProgressHeight"
                            hide-details
                            @change="changePlayer"
                            v-mask="'###'"
                            :min="1"
                            :max="30"
                          >
                            <template #prepend>
                              <div
                                class="minmaxcontainer d-flex align-center body-regular-smaller"
                              >
                                <p
                                  class="minmax first mb-0 page__progressBar--subtext position-absolute"
                                  :style="
                                    alternativeProgressHeight < 99
                                      ? alternativeProgressHeight < 9
                                        ? ' right: 24px'
                                        : 'right: 16px'
                                      : 'right: 8px;'
                                  "
                                >
                                  px
                                </p>
                              </div>
                            </template>
                          </v-input>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pt-3 pb-0 pl-4 range-slider-saveProgress"
                  >
                    <v-row>
                      <v-col cols="6">
                        <div class="d-flex flex-column">
                          <span
                            class="body-regular-small page__progressBar--title"
                          >
                            {{ $t('message.pages.video.velocity') }}
                          </span>
                          <span
                            class="body-regular-smaller page__progressBar--desc-feature"
                            >{{ $t('message.pages.video.velocityDesc') }}</span
                          >
                        </div>
                      </v-col>
                      <v-col cols="6" class="d-flex">
                        <v-slider
                          v-model="alternativeProgressVelocity"
                          :disabled="!alternativeProgress || !hasEditVideoPerm"
                          @change="changePlayer"
                          hide-details
                          :max="30"
                          :min="1"
                          class="d-flex align-center"
                        >
                          <template #prepend>
                            <div
                              class="minmaxcontainer d-flex align-center body-regular-smaller"
                            >
                              <p
                                class="minmax first mb-0 page__progressBar--subtext"
                              >
                                1
                              </p>
                            </div>
                          </template>
                          <template #append>
                            <div
                              class="minmaxcontainer d-flex align-center body-regular-smaller"
                            >
                              <p class="minmax mb-0 page__progressBar--subtext">
                                30
                              </p>
                            </div>
                          </template>
                        </v-slider>
                        <div class="ml-2">
                          <v-input
                            style="width: 65px"
                            size="small"
                            v-model="alternativeProgressVelocity"
                            hide-details
                            @change="changePlayer"
                            v-mask="'##'"
                            :min="0"
                            :max="30"
                          >
                            <template #prepend>
                              <div
                                class="minmaxcontainer d-flex align-center body-regular-smaller"
                              >
                                <p
                                  class="minmax first mb-0 page__progressBar--subtext position-absolute"
                                  :style="
                                    alternativeProgressVelocity < 99
                                      ? alternativeProgressVelocity < 9
                                        ? ' right: 28px'
                                        : 'right: 20px'
                                      : 'right: 12px;'
                                  "
                                >
                                  x
                                </p>
                              </div>
                            </template>
                          </v-input>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pt-3 pb-0 pl-4 range-slider-saveProgress"
                  >
                    <v-row>
                      <v-col cols="6" class="d-flex align-center">
                        <div class="d-flex flex-column">
                          <span
                            class="body-regular-small page__progressBar--title"
                          >
                            {{ $t('message.pages.video.percentage') }}
                          </span>
                          <span
                            class="body-regular-smaller page__progressBar--desc-feature"
                            >{{
                              $t('message.pages.video.percentageDesc')
                            }}</span
                          >
                        </div>
                      </v-col>
                      <v-col cols="6" class="d-flex align-center">
                        <v-slider
                          v-model="alternativeProgress2xLimit"
                          :disabled="!alternativeProgress || !hasEditVideoPerm"
                          @change="changePlayer"
                          hide-details
                          :min="0"
                          :max="100"
                          class="d-flex align-center"
                        >
                          <template #prepend>
                            <div
                              class="minmaxcontainer d-flex align-center body-regular-smaller"
                            >
                              <p
                                class="minmax first mb-0 page__progressBar--subtext"
                              >
                                0
                              </p>
                            </div>
                          </template>
                          <template #append>
                            <div
                              class="minmaxcontainer d-flex align-center body-regular-smaller"
                            >
                              <p class="minmax mb-0 page__progressBar--subtext">
                                100
                              </p>
                            </div>
                          </template>
                        </v-slider>

                        <div class="ml-2">
                          <v-input
                            style="width: 65px"
                            size="small"
                            v-model="alternativeProgress2xLimit"
                            hide-details
                            @change="changePlayer"
                            v-mask="'###'"
                            :min="0"
                            :max="30"
                          >
                            <template #prepend>
                              <div
                                class="minmaxcontainer d-flex align-center body-regular-smaller"
                              >
                                <p
                                  class="minmax first mb-0 page__progressBar--subtext position-absolute"
                                  :style="
                                    alternativeProgress2xLimit < 99
                                      ? alternativeProgress2xLimit < 9
                                        ? ' right: 26px'
                                        : 'right: 18px'
                                      : 'right: 10px;'
                                  "
                                >
                                  %
                                </p>
                              </div>
                            </template>
                          </v-input>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-scroll-x-transition>
            </v-row>
          </v-scroll-x-transition>
        </v-row>
      </v-col>
    </v-row>

    <span
      v-if="internalError"
      class="red--text caption align-text ml-2 mt-2 d-block"
    >
      <v-icon color="red" size="16" class="mt-n1"> mdi-alert-circle </v-icon>
      {{ $t('message.pages.video.errors.addAlternativeProgress') }}
    </span>

    <unsaved-changes-modal />
    <portal to="actions-footer">
      <div class="d-flex flex-row actions-row">
        <v-spacer></v-spacer>
        <v-tooltip max-width="184px" :disabled="!withoutChanges" top>
          <template v-slot:activator="{ on, attrs }">
            <div class="pl-2" v-bind="attrs" v-on="on">
              <base-btn
                v-if="hasEditVideoPerm"
                :disabled="loadingButtonSave || withoutChanges"
                @click="handleUndoChanges"
                type="tertiary"
              >
                {{ $t('message.actions.cancel') }}
              </base-btn>
            </div>
          </template>
          <span>{{ $t('message.noChanges') }}</span>
        </v-tooltip>
        <v-tooltip max-width="184px" :disabled="!withoutChanges" top>
          <template v-slot:activator="{ on, attrs }">
            <div class="pl-2" v-bind="attrs" v-on="on">
              <base-btn
                :disabled="loadingButtonSave || withoutChanges"
                :loading="loadingButtonSave"
                v-if="hasEditVideoPerm"
                @click="handleUpdateAlternativeProgress"
              >
                {{ $t('message.actions.publish') }}
              </base-btn>
            </div>
          </template>
          <span>{{ $t('message.noChanges') }}</span>
        </v-tooltip>
      </div>
    </portal>
  </v-card>
</template>

<script>
import UnsavedChangesModal from '../../../components/UnsavedChangesModal.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import i18n from '@/translations/lang'
import linkHelper from '@/utils/linkHelper.mixin.js'
import _ from 'lodash'

export default {
  name: 'VideoPlayerAlternativeProgress',
  components: {
    UnsavedChangesModal,
  },
  mixins: [linkHelper],
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    liveVideoId: {
      required: false,
    },
    hasEdit: {
      type: Array,
    },
  },
  data: () => ({
    videoId: '',
    loadingButtonSave: false,
    profileId: null,
    profileConfig: {},
    initialConfig: {},
    alternativeProgress: false,
    alternativeProgress2xLimit: 50,
    alternativeProgressVelocity: 5,
    alternativeProgressHeight: 10,
    alternativeProgressDefaultVelocity: false,
    withoutChanges: true,
  }),
  async mounted() {
    this.videoId = this.liveVideoId ? this.liveVideoId : this.$route.params.id
    this.profileId = this.$store.state.video.video.config?.profile
    this.profileConfig = this.$store.state.video.profile?.vsl
    this.alternativeProgress =
      this.$store.state.video.profile?.vsl.alternativeProgress
    this.alternativeProgress2xLimit =
      this.$store.state.video.profile?.vsl.alternativeProgress2xLimit
    this.alternativeProgressVelocity =
      this.$store.state.video.profile?.vsl.alternativeProgressVelocity
    this.alternativeProgressHeight =
      this.$store.state.video.profile?.vsl.alternativeProgressHeight
    this.alternativeProgressDefaultVelocity =
      this.$store.state.video.profile?.vsl.alternativeProgressDefaultVelocity
    this.initialConfig.alternativeProgress = _.cloneDeep(
      this.$store.state.video.profile?.vsl.alternativeProgress
    )
    this.initialConfig.alternativeProgress2xLimit = _.cloneDeep(
      this.$store.state.video.profile?.vsl.alternativeProgress2xLimit
    )
    this.initialConfig.alternativeProgressVelocity = _.cloneDeep(
      this.$store.state.video.profile?.vsl.alternativeProgressVelocity
    )
    this.initialConfig.alternativeProgressHeight = _.cloneDeep(
      this.$store.state.video.profile?.vsl.alternativeProgressHeight
    )
    this.initialConfig.alternativeProgressDefaultVelocity = _.cloneDeep(
      this.$store.state.video.profile?.vsl.alternativeProgressDefaultVelocity
    )
    this.hasEdit.push(this.checkChanges)
    this.$root.$on('discardChanges', () => {
      this.handleUndoChanges()
      this.handleBack()
    })
  },
  watch: {
    alternativeProgress: function () {
      if (!this.alternativeProgress) {
        this.alternativeProgress2xLimit = _.cloneDeep(
          this.initialConfig.alternativeProgress2xLimit
        )
        this.alternativeProgressVelocity = _.cloneDeep(
          this.initialConfig.alternativeProgressVelocity
        )
        this.alternativeProgressHeight = _.cloneDeep(
          this.initialConfig.alternativeProgressHeight
        )
        this.changePlayer()
      }
    },
    '$store.state.video.profile': {
      handler() {
        this.withoutChanges = this.checkChanges()
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      profile: (state) => state.video.profile,
      video: (state) => state.video.video,
      profile_id: (state) => state.video.profile_id,
      internalError: (state) => state.video.internalError,
    }),
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
  },
  methods: {
    ...mapActions('video', [
      'updateProfile',
      'createProfile',
      'setProfileToVideos',
    ]),
    ...mapMutations('video', [
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_VIDEO_PROFILE_ID',
      'UPDATE_STATUS_ERROR',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    activateBar() {
      this.changePlayer()
      if (this.alternativeProgress) {
        this.alternativeProgressDefaultVelocity = true
      }
    },
    openHelp() {
      const link = this.howCustomizeProgressBar()
      window.open(link, '_blank')
    },
    async handleUpdateAlternativeProgress() {
      this.loadingButtonSave = true
      const vsl = {
        ...this.profile.vsl,
        alternativeProgress: this.alternativeProgress,
        alternativeProgress2xLimit: this.alternativeProgress2xLimit,
        alternativeProgressVelocity: this.alternativeProgressVelocity,
        alternativeProgressHeight: this.alternativeProgressHeight,
        alternativeProgressDefaultVelocity:
          this.alternativeProgressDefaultVelocity,
      }
      if (!this.video.config.profile) {
        await this.createProfile(this.videoId)
        this.video.config.profile = this.profile_id
        this.profileId = this.profile_id
        await this.setProfileToVideos([this.profileId, this.videoId])
      }
      const colors = this.profile.colors
      const controls = this.profile.controls.filter(
        (control) => control !== 'progress'
      )
      try {
        await this.updateProfile([
          this.profileId,
          {
            controls,
            vsl,
            colors,
          },
        ])
        this.internalError
          ? ''
          : this.handleSnackbar(this.$t('message.pages.video.changesSaved'))
        this.initialConfig.alternativeProgress = this.alternativeProgress
        this.initialConfig.alternativeProgress2xLimit =
          this.alternativeProgress2xLimit
        this.initialConfig.alternativeProgressVelocity =
          this.alternativeProgressVelocity
        this.initialConfig.alternativeProgressHeight =
          this.alternativeProgressHeight
        this.initialConfig.alternativeProgressDefaultVelocity =
          this.alternativeProgressDefaultVelocity
        this.withoutChanges = true
        this.loadingButtonSave = false
      } catch (e) {
        console.error(e)
        this.loadingButtonSave = false
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    changePlayer() {
      this.profile.vsl['alternativeProgress'] = this.alternativeProgress
      this.profile.vsl['alternativeProgress2xLimit'] =
        this.alternativeProgress2xLimit
      this.profile.vsl['alternativeProgressVelocity'] =
        this.alternativeProgressVelocity
      this.profile.vsl['alternativeProgressHeight'] =
        this.alternativeProgressHeight
      this.profile.vsl['alternativeProgressDefaultVelocity'] =
        this.alternativeProgressDefaultVelocity

      this.UPDATE_STATUS_ERROR(false)
      this.UPDATE_VIDEO_PROFILE(this.profile)
      this.$root.$emit('updateEmbedPreviewChange')
    },
    handleUndoChanges() {
      this.alternativeProgress = _.cloneDeep(
        this.initialConfig.alternativeProgress
      )
      this.alternativeProgress2xLimit = _.cloneDeep(
        this.initialConfig.alternativeProgress2xLimit
      )
      this.alternativeProgressVelocity = _.cloneDeep(
        this.initialConfig.alternativeProgressVelocity
      )
      this.alternativeProgressHeight = _.cloneDeep(
        this.initialConfig.alternativeProgressHeight
      )
      this.alternativeProgressDefaultVelocity = _.cloneDeep(
        this.initialConfig.alternativeProgressDefaultVelocity
      )
      this.changePlayer()
    },
    checkChanges() {
      let verification1 = _.isEqual(
        this.profile.vsl?.alternativeProgress,
        this.initialConfig.alternativeProgress
      )
      let verification2 = _.isEqual(
        this.profile.vsl?.alternativeProgress2xLimit,
        this.initialConfig.alternativeProgress2xLimit
      )
      let verification3 = _.isEqual(
        this.profile.vsl?.alternativeProgressVelocity,
        this.initialConfig.alternativeProgressVelocity
      )
      let verification4 = _.isEqual(
        this.profile.vsl?.alternativeProgressHeight,
        this.initialConfig.alternativeProgressHeight
      )
      let verification5 = _.isEqual(
        this.profile.vsl?.alternativeProgressDefaultVelocity,
        this.initialConfig.alternativeProgressDefaultVelocity
      )
      return (
        verification1 &&
        verification2 &&
        verification3 &&
        verification4 &&
        verification5
      )
    },
    beforeLeave() {
      if (!this.checkChanges()) {
        this.$root.$emit('unsavedChangesModal')
      } else {
        this.UPDATE_STATUS_ERROR(false)
        this.handleBack()
      }
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
        type: 'success',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.range-slider-saveProgress .v-label,
.range-slider-saveProgress .v-label {
  top: -2px;
}
.cursor-pointer {
  cursor: pointer;
}
.position-absolute {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.page__progressBar {
  &--back,
  &--back-icon {
    color: varFigma(brand-60-base);
  }
  &--title,
  &--player-text {
    color: varFigma(neutral-20-dark);
  }
  &--article,
  &--article-icon {
    color: varFigma(neutral-30-base);
  }
  &--subtext,
  &--desc-feature {
    color: varFigma(neutral-40-light);
  }
  .minmax {
    width: 35px;
    &.first {
      text-align: right;
    }
  }
}
</style>
